import React, { useEffect, useState } from 'react';
import { ClockIcon } from 'lucide-react';
const TOTAL_SECONDS = 17 * 60 + 34;
function pad(value: number) {
  return value.toString().padStart(2, '0');
}
export function Countdown({
  note,
  tone = 'light'
}: {
  note?: string;
  tone?: 'light' | 'dark';
}) {
  const [remaining, setRemaining] = useState(TOTAL_SECONDS);
  useEffect(() => {
    const interval = window.setInterval(() => {
      setRemaining(prev => prev <= 1 ? TOTAL_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(interval);
  }, []);
  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor(remaining % 3600 / 60);
  const seconds = remaining % 60;
  const units = [{
    value: pad(hours),
    label: 'Hours'
  }, {
    value: pad(minutes),
    label: 'Min'
  }, {
    value: pad(seconds),
    label: 'Sec'
  }];
  return <div className="w-full text-center" data-id="element-116" data-mp="10d4rbtvzailb">
      <p className={['flex items-center justify-center gap-1.5 text-[11px] font-extrabold uppercase tracking-[0.14em]', tone === 'dark' ? 'text-brand-200' : 'text-brand-700'].join(' ')} data-id="element-117" data-mp="15b698bho4bv7">
        <ClockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-118" data-mp="t1agxatdgeb5" />
        Special offer ends in:
      </p>
      <div className="mt-3 flex items-center justify-center gap-2" role="timer" aria-live="off" aria-label={`Offer ends in ${hours} hours ${minutes} minutes ${seconds} seconds`} data-id="element-119" data-mp="17poizjiyryqn">
        {units.map((unit, index) => <React.Fragment key={unit.label} data-id="element-120" data-mp="a3hee9mnu6ea" data-mpi={index}>
            <div className={['flex min-w-[68px] flex-col items-center rounded-xl px-3 py-2 sm:min-w-[80px]', tone === 'dark' ? 'bg-brand-600' : 'bg-brand-700'].join(' ')} data-id="element-121" data-mp="a4sh064dd83t">
              <span className="font-display text-3xl font-bold leading-none text-white tabular-nums sm:text-4xl" data-id="element-122" data-mp="1zhvy2fitn32x">
                {unit.value}
              </span>
              <span className="mt-1 text-[9.5px] font-bold uppercase tracking-[0.12em] text-brand-200" data-id="element-123" data-mp="1vgartd0sln1p">
                {unit.label}
              </span>
            </div>
            {index < units.length - 1 && <span className="font-display text-2xl font-bold text-brand-400" aria-hidden="true" data-id="element-124" data-mp="x6kkt2xwy27v">
                :
              </span>}
          </React.Fragment>)}
      </div>
      {note ? <p className={['mt-3 text-[13px] font-semibold', tone === 'dark' ? 'text-brand-100' : 'text-brand-800/80'].join(' ')} data-id="element-125" data-mp="9ff64r3plfz5">
          {note}
        </p> : null}
    </div>;
}